// extracted by mini-css-extract-plugin
export default {"resizeFontAwesomeIcon":"CustomLightboxButton_resizeFontAwesomeIcon__MzfqH"};